import { useQuery } from '@tanstack/react-query';
import { fetchProducts, fetchProduct, type ProductListParams } from './request';
import { PRODUCTS_QUERY_KEY, PRODUCT_QUERY_KEY } from './key';

export const useProducts = (params: ProductListParams = {}) => {
  return useQuery({
    queryKey: [PRODUCTS_QUERY_KEY, params],
    queryFn: () => fetchProducts(params),
  });
};

export const useProduct = (id?: number) => {
  return useQuery({
    queryKey: [PRODUCT_QUERY_KEY, id],
    queryFn: () => fetchProduct(id!),
    enabled: !!id,
  });
};
